import Vue from 'vue';
import { VBtn, VList, VMenu, VListItem, VListItemTitle, VTextField, VProgressCircular, VIcon } from 'vuetify/lib';

const Component = Vue.extend({
  name: 'Dashboard',
  props: ['value', 'searchFunction', 'placeholder', 'size', 'hideSearch'],
  components: {
    VBtn,
    VList,
    VMenu,
    VListItem,
    VListItemTitle,
    VTextField,
    VProgressCircular,
    VIcon
  },

  data() {
    return {
      list: [],
      selected: [],
      clickedHandler: 0,
      loading: false,
      query: '',
      searchHandle: 0
    };
  },

  mounted() {
    this.clear();
  },

  watch: {
    async query() {
      if (this.searchHandle) {
        clearTimeout(this.searchHandle);
      }

      this.searchHandle = window.setTimeout(async () => {
        await this.search(this.query);
      }, this.query ? 400 : 0);
    }

  },
  methods: {
    async search(query) {
      this.loading = true;
      const items = await this.searchFunction(query);
      this.list = [];
      items.forEach(x => {
        this.list.push({
          id: x.id,
          value: x.value,
          group: x.group,
          selected: false
        });
      });
      this.list = this.sort(this.list);
      this.loading = false;
    },

    async clear() {
      await this.search('');
      this.selected = [];

      if (this.value) {
        this.value.forEach(x => {
          this.selected.push({
            id: x.id,
            value: x.value,
            group: x.group,
            selected: false
          });
        });
      }

      this.list = this.sort(this.list);
      this.selected = this.sort(this.selected);
    },

    sort(list) {
      const groupBy = list.reduce((acc, curr) => {
        if (!curr.isGroup) {
          if (!acc[curr.group]) {
            acc[curr.group] = [];
          }

          acc[curr.group].push(curr);
        }

        return acc;
      }, {});
      let tempList = [];

      if (Object.keys(groupBy).length === 1 && Object.keys(groupBy)[0] === 'undefined') {
        tempList = tempList.concat(groupBy.undefined);
        tempList = tempList.sort((a, b) => {
          if (a.value.toLowerCase() < b.value.toLowerCase()) {
            return -1;
          }

          return 1;
        });
      } else {
        let sortedKeys = Object.keys(groupBy);
        sortedKeys = sortedKeys.sort((a, b) => {
          if (a.toLowerCase() < b.toLowerCase()) {
            return -1;
          }

          return 1;
        });
        sortedKeys.forEach(g => {
          const label = g === 'undefined' ? 'None' : g;
          tempList.push({
            id: label,
            value: label,
            isGroup: true
          });
          groupBy[g].forEach(x => {
            x.isSubItem = true;
          });
          groupBy[g] = groupBy[g].sort((a, b) => {
            if (a.value.toLowerCase() < b.value.toLowerCase()) {
              return -1;
            }

            return 1;
          });
          tempList = tempList.concat(groupBy[g]);
        });
      }

      return tempList;
    },

    moveToUnSelected() {
      const selected = this.selected.filter(x => x.selected);

      if (selected.length) {
        const notSelected = this.selected.filter(x => !x.selected);
        this.list = this.sort(this.list.concat(selected));
        this.selected = this.sort(notSelected);
        const response = this.selected.filter(x => !x.isGroup).map(x => ({
          id: x.id,
          value: x.value,
          group: x.group
        }));
        this.$emit('input', response);
      }
    },

    moveToSelected() {
      const selected = this.list.filter(x => x.selected);

      if (selected.length) {
        const notSelected = this.list.filter(x => !x.selected);
        this.selected = this.sort(this.selected.concat(selected));
        this.list = this.sort(notSelected);
        const response = this.selected.filter(x => !x.isGroup).map(x => ({
          id: x.id,
          value: x.value,
          group: x.group
        }));
        this.$emit('input', response);

        if (!this.list.length) {
          this.search(this.query);
        }
      }
    },

    moveToSelectedAll() {
      this.selected.forEach(x => {
        x.selected = false;
      });
      this.list.forEach(x => {
        x.selected = true;
      });
      this.moveToSelected();
    },

    moveToUnSelectedAll() {
      this.list.forEach(x => {
        x.selected = false;
      });
      this.selected.forEach(x => {
        x.selected = true;
      });
      this.moveToUnSelected();
    },

    clickedUnselected(id, event) {
      this.selected.forEach(x => {
        x.selected = false;
      });
      this.list.forEach(x => {
        if (event.ctrlKey) {
          if (x.id === id) {
            x.selected = !x.selected;
          }
        } else {
          x.selected = x.id === id;
        }
      });

      if (event.ctrlKey) {
        return;
      }

      if (!this.clickedHandler) {
        this.clickedHandler = window.setTimeout(() => {
          this.clickedHandler = 0;
        }, 300);
      } else {
        clearTimeout(this.clickedHandler);
        this.clickedHandler = 0;
        this.moveToSelected();
      }
    },

    clickedSelected(id, event) {
      this.list.forEach(x => {
        x.selected = false;
      });
      this.selected.forEach(x => {
        if (event.ctrlKey) {
          if (x.id === id) {
            x.selected = !x.selected;
          }
        } else {
          x.selected = x.id === id;
        }
      });

      if (event.ctrlKey) {
        return;
      }

      if (!this.clickedHandler) {
        this.clickedHandler = window.setTimeout(() => {
          this.clickedHandler = 0;
        }, 300);
      } else {
        clearTimeout(this.clickedHandler);
        this.clickedHandler = 0;
        this.moveToUnSelected();
      }
    }

  },
  computed: {
    contentClass() {
      let contentClass = 'listBox-multi-select-menu';

      switch (this.size) {
        case 'medium':
          contentClass += ' medium';
          break;

        case 'large':
          contentClass += ' large';
          break;

        case 'x-large':
          contentClass += ' x-large';
          break;
      }

      return contentClass;
    },

    dropDownText() {
      const a = this.selected;

      if (a.length === 1) {
        return a[0].value;
      }

      if (a.length > 1) {
        return `${a.filter(x => !x.isGroup).length} selected`;
      }

      return this.placeholder || 'None';
    }

  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = Component;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('v-menu', {
    staticStyle: {
      "max-width": "unset !important"
    },
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "content-class": _vm.contentClass
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('div', _vm._g(_vm._b({
          staticClass: "listBox-multi-select-input"
        }, 'div', attrs, false), on), [_vm.loading ? _c('div', [_c('v-progress-circular', {
          attrs: {
            "size": 20,
            "color": "primary",
            "indeterminate": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), !_vm.loading ? _c('div', {
          class: {
            caret: true,
            active: attrs['aria-expanded'] === 'true'
          }
        }) : _vm._e(), _vm._v(" "), !_vm.loading ? _c('div', {
          class: {
            'dropdown-text': true,
            'placeholder': !_vm.selected.length
          }
        }, [_vm._v(_vm._s(_vm.dropDownText))]) : _vm._e()])];
      }
    }])
  }, [_vm._v(" "), !_vm.hideSearch ? _c('v-text-field', {
    staticClass: "search",
    attrs: {
      "label": "Search",
      "append-icon": "fas fa-search",
      "hide-details": "",
      "value": ""
    },
    model: {
      value: _vm.query,
      callback: function ($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-start container"
  }, [_c('div', [_c('div', {
    staticClass: "label"
  }, [_vm._v("Available")]), _vm._v(" "), _c('v-list', {
    staticClass: "panel"
  }, _vm._l(_vm.list, function (item) {
    return _c('v-list-item', {
      key: item.id,
      class: {
        active: item.selected,
        group: item.isGroup,
        subItem: item.isSubItem
      },
      attrs: {
        "disabled": item.isGroup
      },
      on: {
        "click": function ($event) {
          return _vm.clickedUnselected(item.id, $event);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.value))])], 1);
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-column d-flex justify-center"
  }, [_c('div', {
    staticClass: "ma-1"
  }, [_c('v-icon', {
    on: {
      "click": function ($event) {
        return _vm.moveToSelected();
      }
    }
  }, [_vm._v("mdi mdi-chevron-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ma-1"
  }, [_c('v-icon', {
    on: {
      "click": function ($event) {
        return _vm.moveToUnSelected();
      }
    }
  }, [_vm._v("mdi mdi-chevron-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ma-1"
  }, [_c('v-icon', {
    on: {
      "click": function ($event) {
        return _vm.moveToSelectedAll();
      }
    }
  }, [_vm._v("mdi mdi-chevron-double-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ma-1"
  }, [_c('v-icon', {
    on: {
      "click": function ($event) {
        return _vm.moveToUnSelectedAll();
      }
    }
  }, [_vm._v("mdi mdi-chevron-double-left")])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "label"
  }, [_vm._v("Selected")]), _vm._v(" "), _c('v-list', {
    staticClass: "panel"
  }, _vm._l(_vm.selected, function (item) {
    return _c('v-list-item', {
      key: item.id,
      class: {
        active: item.selected,
        group: item.isGroup,
        subItem: item.isSubItem
      },
      attrs: {
        "disabled": item.isGroup
      },
      on: {
        "click": function ($event) {
          return _vm.clickedSelected(item.id, $event);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.value))])], 1);
  }), 1)], 1)])], 1)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-1fcac906_0", {
    source: ".listBox-multi-select-menu{max-width:366px!important;min-width:366px!important;background-color:#fff!important}.listBox-multi-select-menu.container{background-color:#fff}.listBox-multi-select-menu .label{font-size:13px}.listBox-multi-select-menu .panel{border:1px solid #ccc!important;border-radius:4px;width:155px!important;max-width:unset!important;height:200px;overflow-y:scroll;overflow-x:scroll}.listBox-multi-select-menu .panel::-webkit-scrollbar{width:5px}.listBox-multi-select-menu .panel::-webkit-scrollbar-thumb{background-color:#ccc;border-radius:10px}.listBox-multi-select-menu .panel .v-list-item{min-height:25px;padding:0 5px;float:left;min-width:100%}.listBox-multi-select-menu .panel .v-list-item__title{overflow:unset;font-size:13px}.listBox-multi-select-menu .panel .v-list-item.group{font-weight:700}.listBox-multi-select-menu .panel .v-list-item.subItem{padding-left:10px}.listBox-multi-select-menu .panel .v-list-item.active{background-color:#1976d2!important;color:#fff!important}.listBox-multi-select-menu .panel .v-list-item.active .v-list-item__title{color:#fff!important}.listBox-multi-select-input{border:1px solid rgba(0,0,0,.42);padding:10px;min-height:40px;border-radius:4px;position:relative}.listBox-multi-select-input:focus,.listBox-multi-select-input:hover{border-color:#000}.listBox-multi-select-input .caret{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 4px;text-align:center;transition:transform .2s ease}.listBox-multi-select-input .caret.active{transform:rotate(180deg)}.listBox-multi-select-input .caret:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.listBox-multi-select-input .dropdown-text{overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis;width:calc(100% - 25px)}.listBox-multi-select-input .dropdown-text.placeholder{color:#9e9e9e!important;font-weight:400;font-size:14px}.listBox-multi-select-menu .search{background-color:#fff;padding-top:8px;padding-left:12px;padding-right:8px;font-size:13px}.listBox-multi-select-menu .search .v-icon{font-size:13px}.listBox-multi-select-menu .search .v-label{font-size:13px}@media screen and (min-width:500px){.listBox-multi-select-menu.large,.listBox-multi-select-menu.medium,.listBox-multi-select-menu.x-large{max-width:486px!important;min-width:486px!important}.listBox-multi-select-menu.large .panel,.listBox-multi-select-menu.medium .panel,.listBox-multi-select-menu.x-large .panel{width:215px!important}}@media screen and (min-width:700px){.listBox-multi-select-menu.large,.listBox-multi-select-menu.x-large{max-width:666px!important;min-width:666px!important}.listBox-multi-select-menu.large .panel,.listBox-multi-select-menu.x-large .panel{width:305px!important}}@media screen and (min-width:900px){.listBox-multi-select-menu.x-large{max-width:816px!important;min-width:816px!important}.listBox-multi-select-menu.x-large .panel{width:380px!important}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// install function executed by Vue.use()
const install = function installVueListboxMultiselect(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VueListboxMultiselect', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()
// eslint-disable-next-line @typescript-eslint/no-explicit-any


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
